export enum NotepadType {

    TEXT        = 'text',
    RTF         = 'rtf'

}
